import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  display: none;\n\n  ", ":checked + ", " & {\n    display: block;\n  }\n\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", "\n  ", "\n  box-sizing: border-box;\n\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      position: relative;\n      ", "\n\n      ", ":focus + & {\n        background: rgb(208, 224, 232);\n      }\n\n      ", ":hover:not([disabled]) + & {\n        background: rgb(231, 239, 243);\n      }\n\n      & + ", " {\n        margin-left: ", ";\n      }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  z-index: 1;\n  position: absolute;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n\n  * {\n    ", "\n  }\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  background-color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: ", "px;\n\n  & + ", " {\n    margin-left: 20px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import { centeredTranslate, circle } from '../../shared/css';
import useRadioGroupMember from '../utils/useRadioGroupMember';
import { legacySwappableCss } from '../../theme';
var backgroundSize = 40;
var circleSize = 20;
var dotSize = circleSize / 2;
var Label = styled.label(_templateObject(), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'rgb(176, 176, 176)' : 'rgb(51, 51, 51)';
}, function (p) {
  return p.theme.fontCss('body');
}, legacySwappableCss("\n      font-size: 18px;\n      font-weight: 100;\n    ", '')); // LEGACY theme

var legacyRadioBackgroundCss = css(_templateObject2(), circleSize, Label);
var legacyRadioCircleCss = "\n  border: 1px solid rgb(204, 204, 204);\n";
var legacyDotCss = css(_templateObject3(), circle(14), function (p) {
  return p.theme.primary;
});
var legacyContainerCss = 'margin: 7px 0px;'; // END LEGACY theme

var Container = styled.div(_templateObject4(), function (_ref2) {
  var disabled = _ref2.disabled;
  return !disabled && 'cursor: pointer;';
}, legacySwappableCss(legacyContainerCss, ''));
var HiddenRadio = styled.input.attrs({
  type: 'radio'
})(_templateObject5());
/* stylelint-disable selector-type-no-unknown */

var RadioBackground = styled.div(_templateObject6(), legacySwappableCss(legacyRadioBackgroundCss, css(_templateObject7(), circle(backgroundSize), HiddenRadio, HiddenRadio, Label, function (p) {
  return p.theme.spacing(0.5);
})));
var RadioCircle = styled.div(_templateObject8(), centeredTranslate, circle(circleSize), legacySwappableCss(legacyRadioCircleCss, "\n      border: 2px solid rgb(51, 51, 51);\n\n      ".concat(HiddenRadio, ":checked + ").concat(RadioBackground, " & {\n        border-color: rgb(22, 104, 141);\n      }\n\n      ").concat(HiddenRadio, ":disabled + ").concat(RadioBackground, " & {\n        border-color: rgb(176, 176, 176);\n      }\n    ")));
var Dot = styled.div(_templateObject9(), centeredTranslate, HiddenRadio, RadioBackground, legacySwappableCss(legacyDotCss, "\n      ".concat(circle(dotSize), "\n      background-color: rgb(22, 104, 141);\n\n      ").concat(HiddenRadio, ":disabled + ").concat(RadioBackground, " & {\n        background-color: rgb(176, 176, 176);\n      }\n    ")));
/* stylelint-enable selector-type-no-unknown */

var RadioInput = function RadioInput(props) {
  var groupMemberProps = useRadioGroupMember(props.value);

  var _groupMemberProps$pro = _objectSpread(_objectSpread({}, groupMemberProps), props),
      label = _groupMemberProps$pro.label,
      checked = _groupMemberProps$pro.checked,
      inputProps = _objectWithoutProperties(_groupMemberProps$pro, ["label", "checked"]);

  var id = "".concat(inputProps.name, "-").concat(Date.now() + Math.random());
  return /*#__PURE__*/React.createElement(Container, {
    disabled: inputProps.disabled
  }, /*#__PURE__*/React.createElement(HiddenRadio, _extends({}, inputProps, {
    id: id,
    checked: checked,
    "aria-checked": checked
  })), /*#__PURE__*/React.createElement(RadioBackground, null, /*#__PURE__*/React.createElement(RadioCircle, null, /*#__PURE__*/React.createElement(Dot, null))), /*#__PURE__*/React.createElement(Label, {
    htmlFor: id,
    disabled: inputProps.disabled
  }, label));
};

export default RadioInput;